module.exports = __webpack_public_path__ + "img/9788975278334.b0a3bf59.jpg";